import {
  Box,
  Chip
} from '@mui/material';
import React from 'react';
import { useGetSessionQuery } from '../services/api';

export function SessionTags({
  guid
}: {
  guid?: string;
}) {
  const { data: session } = useGetSessionQuery(guid);
  return (
    <Box
      flexDirection="row"
      marginTop={2}
      sx={{
        "& .MuiChip-root": {
          borderRadius: '4px'
        }
      }}
    >
      {session?.tags.map(tag => (
        <React.Fragment key={tag}>
          <Chip
            label={tag}
            style={{
              fontSize: 13,
              fontWeight: 500,
              marginBottom: 2,
            }}
            variant="outlined"
          />
          &nbsp;
        </React.Fragment>
      ))}
    </Box>
  );
}
